import { JSON_SUBSETS_KEY } from '../../constants';
import {
  BuildContext,
  ExportOptions,
  ExportPayloadChildSection,
  ExportPayloadSection,
} from '../../types';
import reportProgressAndMaybeYield from '../reportProgressAndMaybeYield';
import resolveJsonCellValue from './resolveJsonCellValue';

const appendJsonRows = async (
  targetLines: string[],
  rows: Record<string, unknown>[],
  columns: ExportPayloadSection['columns'],
  options: ExportOptions,
  indent: string,
  context: BuildContext,
  childSections: ExportPayloadChildSection[] = [],
  masterIdItem?: string
): Promise<void> => {
  const innerIndent = `${indent}  `;
  const slaveIndent = `${innerIndent}  `;
  const slaveRowsIndent = `${slaveIndent}  `;
  const includeSlaves = childSections.length > 0 && !!masterIdItem;

  for (let rowIndex = 0; rowIndex < rows.length; rowIndex += 1) {
    const row = rows[rowIndex];
    const isLastRow = rowIndex === rows.length - 1;
    const masterId = masterIdItem ? String(row[masterIdItem] ?? '') : '';

    targetLines.push(`${indent}{`);

    columns.forEach((column, columnIndex) => {
      const isLastFieldInRow =
        columnIndex === columns.length - 1 && !includeSlaves;
      const value = resolveJsonCellValue(row, column, options);
      targetLines.push(
        `${innerIndent}${JSON.stringify(column.name)}: ${JSON.stringify(
          value
        )}${isLastFieldInRow ? '' : ','}`
      );
    });

    if (includeSlaves) {
      targetLines.push(`${innerIndent}"${JSON_SUBSETS_KEY}": {`);

      for (
        let slaveIndex = 0;
        slaveIndex < childSections.length;
        slaveIndex += 1
      ) {
        const childSection = childSections[slaveIndex];
        const isLastSlave = slaveIndex === childSections.length - 1;
        const childRows = childSection.rowsByMasterId.get(masterId) ?? [];
        const keyPrefix = `${slaveIndent}${JSON.stringify(childSection.id)}: `;

        if (childRows.length === 0) {
          targetLines.push(`${keyPrefix}[]${isLastSlave ? '' : ','}`);
          continue;
        }

        targetLines.push(`${keyPrefix}[`);
        await appendJsonRows(
          targetLines,
          childRows,
          childSection.columns,
          options,
          slaveRowsIndent,
          context
        );
        targetLines.push(`${slaveIndent}]${isLastSlave ? '' : ','}`);
      }

      targetLines.push(`${innerIndent}}`);
    }

    targetLines.push(`${indent}}${isLastRow ? '' : ','}`);
    await reportProgressAndMaybeYield(context);
  }
};

export default appendJsonRows;
